import { createRoot } from "react-dom/client";
import React, {Fragment, useState, useEffect, useRef, useCallback, useMemo} from "react";
import axios from "axios";
import SelectTaxa from "./SelectTaxa";
const apiRoot = process.env.MIX_API_ROOT;
import ErrorDisplay from "./ErrorDisplay";
import debounce from 'lodash.debounce';

const initCatalogNumber = (elementId) => {
    const CatalogContainer = document.getElementById(elementId);
    if (CatalogContainer) {
        const errorStatus = CatalogContainer.attributes.error.value;
        const errorMessage =
            CatalogContainer.attributes["error-message"].value;
        const catalogNumber = CatalogContainer.attributes["catalog-number"].value;
        const selectCatalogRoot = createRoot(CatalogContainer);
        selectCatalogRoot.render(
            <CatalogNumberInput
                catalogNumber={catalogNumber}
                errorStatus={errorStatus}
                errorMessage={errorMessage}
            />
        );
    }
}

const CatalogNumberInput = (props) => {
    const [catalogNumber, setCatalogNumber] = useState(props.catalogNumber);
    const [errorStatus, setErrorStatus] = useState(props.errorStatus);
    const [errorMessage, setErrorMessage] = useState(props.errorMessage);

    const checkCount = () => {
        const url = apiRoot + "/specimen-catalog-number-count";
        const params = { params: {catalog_no: catalogNumber} };
        axios.get(url, params).then((response) => {
            console.log(response.data)
            if (response.data > 0) {
                setErrorStatus("yes")
                setErrorMessage('Catalog number exists.')
            } else if (props.errorStatus) {
                setErrorStatus(props.errorStatus);
                setErrorMessage(props.errorMessage);
            }
        });
    }

    const memoEffect = useMemo(
        () => debounce(checkCount, 300)
        , [setErrorStatus, setErrorMessage, props, catalogNumber]
    );

    useEffect(() => {
        memoEffect();
    }, [catalogNumber]);

    let inputClass = '';
    if(errorStatus === 'valid') {
        inputClass = 'is-valid';
    } else if (errorStatus === 'yes'){
        inputClass = 'is-invalid'
    }

    const changeHandler = (e) => {
        setCatalogNumber(e.target.value)
    }

    return (
        <Fragment>
            <label htmlFor="catalog-number-input" className="form-label">Catalog No.</label>
            <input id="catalog-number-input" className={"form-control " + inputClass} name={'catalog-number'} type={'text'} value={catalogNumber} onChange={changeHandler}></input>

            <ErrorDisplay error={errorStatus} errorMessage={errorMessage} />
        </Fragment>
    );
}

export { CatalogNumberInput as default, initCatalogNumber};
